import React from 'react';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from 'base/containers/App';
import { createCustomColorTheme } from 'base/theme/OnlineOrderingTheme';
import { browserHistory } from 'config/store';
import get from 'lodash/get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FlagsProvider } from 'base/utils/flags';
import { flags } from 'base/constants/flags';

/**
 * The component wraps the App component with Router so
 * the App component can access to location props from
 * react-route.
 */
class AppContainer extends React.PureComponent {
  static propTypes = {
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    bodyColor: PropTypes.string,
    isStaff: PropTypes.bool
  };

  render() {
    const theme = createCustomColorTheme(this.props);
    return (
      <FlagsProvider flags={{ ...flags, isStaff: this.props.isStaff }}>
        <MuiThemeProvider theme={theme}>
          <ConnectedRouter history={browserHistory}>
            <Route render={props => <App {...props} />} />
          </ConnectedRouter>
          <CssBaseline />
        </MuiThemeProvider>
      </FlagsProvider>
    );
  }
}

const mapStateToProps = state => {
  const { account, user } = state;

  return {
    primaryColor: get(account, 'processed_theme_options.primary_color'),
    secondaryColor: get(account, 'processed_theme_options.accent_color'),
    bodyColor: get(account, 'processed_theme_options.body_color'),
    isStaff: user.is_staff
  };
};

export default connect(mapStateToProps)(AppContainer);
